import React, { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';
import { ACCOUNT_USER_ROLE } from '@enums';
import { useStore } from '@hooks';
import { Menu } from 'antd';
import { observer } from 'mobx-react';
import { BLOCKED_MENU_ITEMS, getMenuItemsWithHandlers } from './constants';

const HeaderMenu = observer(() => {
    const store = useStore();
    const { hasGUID, isBlocked } = store.accountsStore;
    const { me } = store.authStore;
    const navigate = useNavigate();
    const location = useLocation();

    const isDeveloper = me?.permission?.role === ACCOUNT_USER_ROLE.DEVELOPER;

    const handleCampaignsClick = useCallback(
        (e, path) => {
            if (path === ROUTE_PATHS.CAMPAIGNS) {
                e.preventDefault();

                if (
                    location.pathname === ROUTE_PATHS.CAMPAIGNS ||
                    location.pathname === ROUTE_PATHS.CAMPAIGNS_PRE_WIZARD
                ) {
                    return;
                }

                navigate(ROUTE_PATHS.CAMPAIGNS_LOADING + '?step=false');
            }
        },
        [navigate, location.pathname]
    );

    const menuItems = useMemo(() => {
        const protoItems = isBlocked ? BLOCKED_MENU_ITEMS : getMenuItemsWithHandlers(handleCampaignsClick);

        let items = protoItems.map((item) => {
            const isCampaignsActive =
                item.key === ROUTE_PATHS.CAMPAIGNS &&
                (location.pathname === ROUTE_PATHS.CAMPAIGNS ||
                    location.pathname === ROUTE_PATHS.CAMPAIGNS_LOADING ||
                    location.pathname === ROUTE_PATHS.CAMPAIGNS_PRE_WIZARD ||
                    location.pathname.startsWith(ROUTE_PATHS.CAMPAIGNS_CREATE));

            return {
                ...item,
                active: isCampaignsActive || location.pathname.includes(item.key)
            };
        });

        if (!hasGUID && !isBlocked) {
            items = items.filter((menuItem) => menuItem.label !== 'Insights');
        }

        return items;
    }, [location.pathname, hasGUID, isBlocked, handleCampaignsClick]);

    if (isDeveloper) {
        return null;
    }

    return (
        <Menu
            data-e2e='header_menu'
            disabledOverflow
            mode='horizontal'
            selectedKeys={[menuItems.find((item) => item.active)?.key]}
            items={menuItems.map(({ active, ...item }) => item)}
        />
    );
});

export default HeaderMenu;
